<template>
  <div>
    <!-- TABS//S -->
    <div class="tab-design">
      <ul>
        <li><router-link to="/notice">공지사항</router-link></li>
        <li><router-link to="/event">이벤트</router-link></li>
      </ul>
    </div>
    <!-- TABS//E -->
    <!-- NOTICE LIST//S -->
    <div class="board-list">
      <ul>
        <li v-for="(notice, index) in noticeList" :key="index" class="notice" v-bind:class="[notice.notiYn]">
          <router-link :to="`/notice/view/${notice.no}`" class="well">
          <h4><strong v-if="notice.notiYn ==='Y'">[고정]</strong> {{notice.title}}</h4>
          <div class="clearfix">
            <span class="pull-right date">{{notice.regDate}}</span>
          </div>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- NOTICE LIST//E -->
  </div>
</template>
<script>
import Api from "@/common/Api";
import Moment from "moment";
export default {
  mounted() {
    this.getNoticeList()
  },
  data() {
    return {
      actives:0,
      noticeList:[],
      paginationTotal: 0,
      paginationPer: 10,
      pagination: {
        currentPage: 1
      }
    };
  },
  methods: {
    getNoticeList() {
      Api.Board.getNotice({})
      .then(response => {
        const data = response.body;
        _.find(data, (row, idx) => {
          if ( row.notiYn === 'Y' ) { // 공지
            this.noticeList.push({
              no: row.id,
              link: row.id,
              title: row.title,
              notiYn: row.notiYn,
              regDate: Moment(row.regDate).format('YYYY-MM-DD')
            })
          }
        })
        _.find(data, (row, idx) => {
          if ( row.notiYn !== 'Y' ) { // 공지 외
            this.noticeList.push({
              no: row.id,
              link: row.id,
              title: row.title,
              notiYn: row.notiYn,
              regDate: Moment(row.regDate).format('YYYY-MM-DD')
            })
          }
        })
        // _.map(data, (row) => {
        //   this.noticeList.push({
        //     id: row.id,
        //     notiYn: row.notiYn,
        //     title: row.title,
        //     regDate: Moment(row.regDate).format('YYYY-MM-DD'),
        //     contents: row.contents,
        //   })
        // })
      })
      .catch(err => {
      })
    }
  }
};
</script>
<style>
</style>
